/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import useSeo from '../../hooks/useSeo.ts'

const PrivacyPolicy = () => {
	useSeo({ title: 'Privacy Policy | Wedding Camera', description: 'Wedding Camera privacy policy.', path: '/privacy-policy', lang: 'en' })
	return (
		<div style={{ fontFamily: 'Arial, sans-serif', lineHeight: '1.6', color: '#333', padding: '20px' }}>
			<h1 style={{ color: '#444' }}>Privacy Policy</h1>
			<p><strong>Last updated:</strong> 17.08.2026</p>

			<h2 style={{ color: '#444' }}>Your Privacy Matters to Us</h2>
			<p>
				This Privacy Policy explains how the Wedding Camera application (hereinafter: "the Application")
				collects, uses, and protects user information.
			</p>

			<h2 style={{ color: '#444' }}>What Information Do We Collect?</h2>
			<ul>
				<li>
					<strong>User Data:</strong> We collect basic information, such as email addresses, necessary for account registration.
				</li>
				<li>
					<strong>Photos:</strong> Users can upload photos to the Application. Uploaded photos are private and only accessible to users linked to the specific event.
				</li>
				<li>
					<strong>Wedding Planner Data:</strong> When you register for the free Wedding Planner
					we collect your email address, your wedding date, and the first names of the couple,
					along with the language you're browsing the site in. Registering also creates internal
					records tied to your consent (a timestamp and a unique unsubscribe identifier) and to
					the promotional offer described below (a discount code, and whether it has been sent,
					reminded, or redeemed). The Wedding Planner itself gives you a guest list and a seating
					plan tool. Your wedding date is used to time a promotional offer: a single discount
					code sent between 2 and 6 weeks before your wedding, followed by one reminder email
					between 1 and 3 weeks before your wedding if the offer has not yet been redeemed.
				</li>
			</ul>

			<h2 style={{ color: '#444' }}>How Do We Use Your Data?</h2>
			<ul>
				<li>
					<strong>Service Delivery:</strong> To enable the upload, storage, and viewing of photos.
				</li>
				<li>
					<strong>Content Moderation:</strong> All photos are subject to manual review to ensure compliance with our Acceptable Use Policy.
				</li>
				<li>
					<strong>Promotional Email:</strong> If you gave explicit consent during Wedding Planner
					registration, we send at most two promotional emails before your wedding, from
					promo@weddingcamera.app. Every promotional email carries a one-click unsubscribe link,
					and unsubscribing takes effect immediately without affecting your access to the planner.
				</li>
				<li>
					<strong>Automated Delivery Management:</strong> To protect our ability to deliver email
					reliably, we automatically and permanently stop sending promotional email to an address
					that hard-bounces or is reported as spam by your mail provider. This happens without
					manual review and does not affect your access to the planner.
				</li>
			</ul>

			<h2 style={{ color: '#444' }}>Data Security</h2>
			<ul>
				<li>All uploaded photos are securely stored using industry-standard security measures.</li>
				<li>SSL encryption is used to protect your data during transmission.</li>
			</ul>

			<h2 style={{ color: '#444' }}>Data Retention and Deletion</h2>
			<ul>
				<li>
					We do not currently delete Wedding Planner data automatically after your wedding date.
					It is kept until you or we act on one of the options below.
				</li>
				<li>
					You can withdraw consent at any time using the unsubscribe link in any promotional
					email. This stops all promotional email but keeps your planner accessible.
				</li>
				<li>
					To have your data deleted entirely, email <a href="mailto:hello@mcode.hr" style={{ color: '#007BFF', textDecoration: 'none' }}>hello@mcode.hr</a>. We delete your
					lead record and associated marketing data within 30 days.
				</li>
			</ul>

			<h2 style={{ color: '#444' }}>Your Rights</h2>
			<ul>
				<li>You have the right to request the deletion of your account and associated photos.</li>
				<li>
					You may contact us at <a href="mailto:hello@mcode.hr" style={{ color: '#007BFF', textDecoration: 'none' }}>hello@mcode.hr</a> to exercise your rights under applicable data protection laws.
				</li>
			</ul>

			<h2 style={{ color: '#444' }}>Contact Us</h2>
			<p>
				For any questions or concerns about this Privacy Policy, email us at{' '}
				<a href="mailto:hello@mcode.hr" style={{ color: '#007BFF', textDecoration: 'none' }}>hello@mcode.hr</a>.
			</p>
		</div>
	)
}

export default PrivacyPolicy
